module.exports = __webpack_public_path__ + "static/media/prize-5.60b9c0e4.png";